import React, { useState, useEffect } from "react";

const Dashboard = () => {
    const [username, setUsername] = useState("");

    useEffect(() => {
        const user = JSON.parse(localStorage.getItem("sapUser"));
        setUsername(user?.FullName || "");
    }, []);
    
    return (
        <div className="container mt-5">
            <h2>Bienvenido, {username}</h2>
        </div>
    );
};

export default Dashboard;
